import React from 'react'
import { Trans, t } from '@lingui/macro'

import { CampaignMessageTypeEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import { Modal } from '../../../components/common/modal/Modal'
import { linkBuilder } from '../../../../../shared/linkBuilder'
import Link from '../../../components/common/link/Link'
import IconBubble from '../../../components/common/icon/IconBubble'
import { ICampaignDataState } from './NotificationsTab'
import { useDisableCampaignsByIdsMutation } from '../operations/disableCampaignByIds.codegen'
import { ButtonClean, ButtonDanger } from 'front-end/src/components'

interface IDisableCampaignWithMessageActionModal {
  type: CampaignMessageTypeEnum
  data: ICampaignDataState[]
  onHide: () => void
  show?: boolean
  onDisable: () => void
}

const NotificationsType = {
  SMS: <Trans>SMS messaging</Trans>,
  SLACK: <Trans>Slack integration</Trans>,
  MSTEAMS: <Trans>Microsoft Teams integration</Trans>
}

const DisableCampaignWithMessageActionModal = ({
  type,
  data,
  onHide,
  show,
  onDisable
}: IDisableCampaignWithMessageActionModal) => {
  if (!data) {
    return null
  }

  const [disableCampaignsByIds] = useDisableCampaignsByIdsMutation()
  const handleDisable = async () => {
    const ids = data.map((value) => value.id)
    await disableCampaignsByIds({ variables: { id: ids } })
    onDisable()
  }

  return (
    <Modal
      className={'ModalDisableMessaging'}
      header={t`You really want to disable ${NotificationsType[type]}`}
      show={show}
      controls={[
        <ButtonClean onClick={onHide} key={1}>
          <Trans>Cancel</Trans>
        </ButtonClean>,
        <ButtonDanger key={2} onClickAsync={async () => handleDisable()}>
          <Trans>Disable campaigns</Trans>
        </ButtonDanger>
      ]}
      onHide={onHide}
    >
      <div className={'Modal__relatedItems'}>
        <div className={'Modal__relatedItems__column'}>
          <IconBubble size="medium" />
        </div>
        <div className={'Modal__relatedItems__column'}>
          <p>
            <Trans>
              Some campaigns contains {type} messaging actions. Disabling{' '}
              {NotificationsType[type]} will automatically{' '}
              <strong>deactivate</strong> these campaigns:
            </Trans>
          </p>
          <ul>
            {data.map((campaign) => {
              return (
                <li key={campaign.id}>
                  <Link href={`${linkBuilder.campaign(campaign.id)}`}>
                    <span className={'Modal__relatedItems__importantInfo'}>
                      <strong>{campaign.name}</strong>{' '}
                    </span>
                    {campaign.author && (
                      <small>
                        (<Trans>by</Trans> {campaign.author.email})
                      </small>
                    )}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default DisableCampaignWithMessageActionModal
